<template>
    <div class="header">
        <img
            class="logo"
            :src="require('@/assets/upmood-logo.svg')"
            @click="$router.push({ name: isLoggedIn ? 'Dashboard' : 'SignIn' })"
        />

        <button v-if="isLoggedIn" @click="logout()">Logout</button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({
			isLoggedIn: 'isLoggedIn'
		})
	},
    
	methods: {
		logout () {
			this.$store.dispatch('logout')
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
    background-color: #291E39;
    width: 100%;
    height: 100px;
    box-shadow: 0px 1px 3px #00000029;
    display: flex;
    align-items: center;
    padding: 0 120px;

    @include mobile {
        padding: 0 15px;
    }

    .logo {
        width: 52px;
        height: 52px;
        cursor: pointer;
    }

    button {
        margin-left: auto;
        color: #BAB1C9;
        font-weight: 600;
        font-size: 18px;
        background-color: transparent;
        border: none;
        outline:none;
    }
}
</style>
